// const BOT_BASE_URL = "http://localhost:8000/"
const BOT_BASE_URL = 'https://bot.abanprime.com/'
// const API_URL = 'http://localhost:4040'
const API_URL = process.env.VUE_APP_API_URL ?? 'https://api.abanprime.com'
const PRODUCT = process.env.VUE_APP_PRODUCT ?? 'prime'
const PRODUCT_TITLE = process.env.VUE_APP_PRODUCT_TITLE ?? 'Aban Prime'
const PRODUCT_WEBSITE = process.env.VUE_APP_PRODUCT_WEBSITE ?? 'AbanPrime.com'
const TURNSTILE_SITE_KEY = '0x4AAAAAADwBw_ocL371ufFM'
const SENTRY_DSN =
  process.env.VUE_APP_SENTRY_DSN ??
  'https://b6b0e6fea7ee0c48f1aad53748612df1@o4508370794315776.ingest.de.sentry.io/4508370796019792'
const SENTRY_ENVIRONMENT = process.env.VUE_APP_SENTRY_ENVIRONMENT ?? 'production'
export default {
  API_URL,
  BOT_BASE_URL,
  PRODUCT_TITLE,
  PRODUCT_WEBSITE,
  PRODUCT,
  TURNSTILE_SITE_KEY,
  SENTRY_DSN,
  SENTRY_ENVIRONMENT
}
